import React from "react";
import AppContainer from "./AppContainer";
import AppContextProvider from "./AppContextProvider";
import Main from "./components/Main";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./pages/Home";

import CandidateHome from "./pages/candidate/CandidateHome";
import CandidateMOJHome from "./pages/candidate/CandidateMOJHome";
import CandidateCreate from "./pages/candidate/CandidateCreate";
import CandidateCreatePIL from "./pages/candidate/CandidateCreatePIL";
import CandidateEdit from "./pages/candidate/CandidateEdit";
import CandidateEditPIL from "./pages/candidate/CandidateEditPIL";
import Candidate from "./pages/candidate/Candidate";
import CandidateMOJ from "./pages/candidate/CandidateMOJ";
import CandidateZambion from "./pages/candidate/CandidateZambion";
import CandidateCancel from "./pages/candidate/CandidateCancel";
import CandidateComplete from "./pages/candidate/CandidateComplete";
import CandidateReallocate from "./pages/candidate/CandidateReallocate";
import CandidateArchive from "./pages/candidate/CandidateArchive";

import UserHome from "./pages/admin/UserHome";
import UserCreate from "./pages/admin/UserCreate";
import UserEdit from "./pages/admin/UserEdit";
import AssetFileHome from "./pages/admin/AssetFileHome";
import AssetFileCreate from "./pages/admin/AssetFileCreate";
import CandidateOffer from "./pages/candidate/CandidateOffer";

import JobCodeList from "./pages/admin/JobCodeList";
import JobCodeAdmin from "./pages/admin/JobCodeAdmin";
import JobCodeRateList from "./pages/admin/JobCodeRateList";
import JobCodeRateAdmin from "./pages/admin/JobCodeRateAdmin";

const App = () => {
	return (
		<AppContainer>
			<Router>
				<AppContextProvider>
					<Main>
						<Routes>
							<Route path="/candidate/create" element={<CandidateCreate />} />
							<Route path="/candidate/create-pil" element={<CandidateCreatePIL />} />
							<Route
								path="/candidate-edit/:candidateId"
								element={<CandidateEdit />}
							/>
							<Route
								path="/candidate-pil-edit/:candidateId"
								element={<CandidateEditPIL />}
							/>
							<Route path="/candidate/:candidateId" element={<Candidate />} />

							<Route
								path="/my-candidates"
								element={
									<CandidateHome mode="my-candidates" key="my-candidates" />
								}
							/>

							<Route
								path="/candidates"
								element={
									<CandidateHome mode="all-candidates" key="all-candidates" />
								}
							/>

							<Route
								path="/my-moj"
								element={<CandidateMOJHome mode="my-moj" key="my-moj" />}
							/>
							<Route
								path="/moj"
								element={<CandidateMOJHome mode="all-moj" key="all-moj" />}
							/>
							<Route
								path="/candidate-moj/:candidateId"
								element={<CandidateMOJ />}
							/>
							<Route
								path="/candidate-cancel/:candidateId"
								element={<CandidateCancel />}
							/>
							<Route
								path="/candidate-offer/:candidateId"
								element={<CandidateOffer />}
							/>
							<Route
								path="/candidate-zambion/:candidateId"
								element={<CandidateZambion />}
							/>
							<Route
								path="/candidate-complete/:candidateId"
								element={<CandidateComplete />}
							/>
							<Route
								path="/candidate-reallocate/:candidateId"
								element={<CandidateReallocate />}
							/>

							<Route path="/archive" element={<CandidateArchive />} />
							<Route path="/" element={<Home />} />

							<Route path="/user/create" element={<UserCreate />} />
							<Route path="/user/:userId" element={<UserEdit />} />
							<Route path="/users" element={<UserHome />} />

							<Route path="/file/create" element={<AssetFileCreate />} />

							<Route path="/files" element={<AssetFileHome />} />

							<Route path="/job-codes" element={<JobCodeList />} />
							<Route path="/job-code/create" element={<JobCodeAdmin />} />
							<Route
								path="/job-code/edit/:jobCodeId"
								element={<JobCodeAdmin />}
							/>

							<Route path="/job-code-rates" element={<JobCodeRateList />} />
							<Route
								path="/job-code-rate/create"
								element={<JobCodeRateAdmin />}
							/>
							<Route
								path="/job-code-rate/edit/:jobCodeRateId"
								element={<JobCodeRateAdmin />}
							/>

							<Route path="/" element={<h2>Page not found</h2>} />
						</Routes>
					</Main>
				</AppContextProvider>
			</Router>
		</AppContainer>
	);
};
export default App;
